<ion-app>
  <app-preload-img/>
  <ion-router-outlet [animated]="false"/>
</ion-app>
